import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  getWebhookDetail,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
}) => {
  const dataColumns = [
    // {
    //   field: 'webhook_log_id',
    //   title: '#',
    //   editable: false,
    //   show: true,
    //   width: '50px',
    //   minResizableWidth: 250,
    //   filterable: true,
    //   className: 'grid-cells',
    // },
    {
      field: 'author',
      title: 'Author',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'repo',
      title: 'Repository',
      editable: false,
      show: true,
      width: '100px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'created_date',
      title: 'Date',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 50,
      filterable: true,
      className: 'grid-cells',
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'Created_date',
        }),
      cell: GridDateCell,
    },
    {
      field: 'status',
      title: 'Status',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'action',
      title: 'Action',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 50,
      filterable: false,
      excludeFromFilter: true,
      cell: (props) => (
        <td className="rollouts-action">
          <>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                getWebhookDetail(props.dataItem.webhook_log_id);
              }}
            >
              <FontAwesomeIcon icon={faEye} title="View Details" />
            </Link>
          </>
        </td>
      ),
    },
  ];

  return dataColumns;
};
export default DataColumns;
